// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyDKZ14rCslySYCZ1FlceghlnQSmA0THjlQ',
    authDomain: 'inmenu-dc7ef.firebaseapp.com',
    databaseURL: 'https://inmenu-dc7ef.firebaseio.com',
    projectId: 'inmenu-dc7ef',
    storageBucket: 'inmenu-dc7ef.appspot.com',
    messagingSenderId: '19069090878',
    appId: '1:19069090878:web:ced22ebaa16939ef17256f',
    measurementId: 'G-E7SHTLS66E'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

export const urls = {
  appBaseUrl: 'http://localhost:44391',
  apiBaseUrl: 'https://adminapi.inmenu.am/api',
  signalRUrl: 'https://api.inmenu.am/chat'
};
